module.exports = __webpack_public_path__ + "img/cross.20d1b0d7.svg";